import PulseSkipControls from './PulseControls/PulseSkipControls'
import PulsePauseControls from './PulseControls/PulsePauseControls'

export function PulseControls(props) {
	const { hasPauseAd } = props
	return <div>{hasPauseAd ? <PulsePauseControls {...props} /> : <PulseSkipControls {...props} />}</div>
}
export default PulseControls
